export class HrPayConstantPublicKey {
    private static readonly keyPrefix = 'hrPayConstantPublic';
    public static pageHeader = `${HrPayConstantPublicKey.keyPrefix}.pageHeader`;
    public static value = `${HrPayConstantPublicKey.keyPrefix}.value`;
}
